import React, { Fragment, useEffect, useState } from 'react'
import MasterComponentWraper from '../../Backend/MasterComponentWraper'
import { useParams } from 'react-router-dom';
import FormValidator from '../../../inc/FormValidator';
import Api from '../../../inc/Api';
import Settings from '../../../inc/Settings';
import SimpleLoading from '../../Loading/SimpleLoading';
import Collapse from '../../inc/Collapse';
import FieldsRenderer from '../../Purchase Orders Internal/Edit PO/FieldsRenderer';
import { areObjectsDifferent, getOnlyChangedValuesForApiPayload, getPopupMessageBasedOnStatus } from '../../../inc/Validation';
import NavigationHeder from '../../Navigations/NavigationHeder';
import LinkBtn from '../../inc/LinkBtn';
import Button from '../../inc/Button';
import Helper from '../../../inc/Helper';
import CommonAPICalls from '../Common Integration Calls/CommonApiCalls';

let defaultApiDetailsFormsObject = null;
const ApiDetailsFormsDetailView = () => {
  const [appMaster, setAppMaster] = useState([]);
  const [apiDetailsFormsData, setApiDetailsFormsData] = useState({});

  const [loading, setLoading] = useState(true); 

  const { id } = useParams();

  let getByIdApiCall = false; 

  useEffect(() => { 
    getApiDetailsFormsById();
    fetchDataForAppMaster();
   }, [])

  let validator;

  const validationConfigure = () => {
    let fieldConfig = [ 
      { name: "title", displayName: "Title", types: ["Required"] },
      { name: "enum_details", displayName: "Enum details", types: ["Required"] },
      { name: "field", displayName: "Field", types: ["Required"] }, 
      { name: "table", displayName: "Table", types: ["Required"] }, 
      { name: "api", displayName: "Api", types: ["Required"] }, 
      { name: "type", displayName: "Type", types: ["Required"] },
      { name: "default_value", displayName: "Default value", types: ["Required"] },
      { name: "reference_api", displayName: "Reference api", types: ["Required"] },
    ];

    if(!validator) {
      validator = new FormValidator(fieldConfig)
    }
  }

  validationConfigure()

  const getApiDetailsFormsById = () => { 
    if(getByIdApiCall) return;

    getByIdApiCall = true;
    setLoading(true);

    let api = Api;
    api.setUserToken()
    api.axios().get(Settings.apiAppUrl+`/lynkaz-api/${id}/`,{}).then(function(res){
      if(res?.status === 200){ 
        setApiDetailsFormsData(res?.data);
        defaultApiDetailsFormsObject = res?.data;
        setLoading(false);
      } else {
        Helper.alert(res?.data?.message, 'error')
      }
    }).catch((res) => { 
      getPopupMessageBasedOnStatus(res) 
      setLoading(false)
    })
  }
 
  const fetchDataForAppMaster = async () => {
    const apiCalls = new CommonAPICalls();
    try {
      const systemAppMasterResponse = await apiCalls.getSystemApiDetails();
      if (systemAppMasterResponse) {
        setAppMaster(systemAppMasterResponse);
      };
    } catch (error) { 
      setAppMaster([]); 
    }
  }

  const ApiDetailsForms = () => { 
    let textBoxInputSettings = [
      {
        className: "col-lg-4",
        label: "Title",
        inputType: "text",
        id: "title",
        required: true,
        name: "title",
      },
      {
        className: "col-lg-4",
        label: "Enum details",
        inputType: "text",
        id: "enum_details",
        required: true,
        name: "enum_details",
      },
      {
        className: "col-lg-4",
        label: "Field",
        inputType: "text",
        id: "field",
        required: true,
        name: "field",
      }, 
      {
        className: "col-lg-4",
        label: "Table",
        inputType: "text",
        id: "table",
        required: true,
        name: "table",
      }, 
      {
        className: "col-lg-4",
        label: "Api",
        inputType: "dropdown", 
        options: appMaster, 
        id: "api",
        required: true,
        name: "api",
      }, 
      {
        className: "col-lg-4",
        label: "Type",
        inputType: "text",
        id: "type",
        required: true,
        name: "type",
      },
      {
        className: "col-lg-4",
        label: "Default value",
        inputType: "text",
        id: "default_value",
        required: true,
        name: "default_value",
      },
      {
        className: "col-lg-4",
        label: "Reference api",
        inputType: "dropdown", 
        options: appMaster, 
        id: "reference_api",
        required: true,
        name: "reference_api",
      },
    ];

    return (
      <Collapse open={true} title={"General"}>
        <div className='row mb-3'>
          <FieldsRenderer fieldsArray={textBoxInputSettings} updateState={setApiDetailsFormsData} currentState={apiDetailsFormsData} />
        </div>
      </Collapse>
    )
  }

  const SaveHandler = () => {
    if(!areObjectsDifferent(defaultApiDetailsFormsObject, apiDetailsFormsData)) return;
    
    let validData = {
      ...apiDetailsFormsData
    };

    if(!validator.isValid(validData)){
      validator.displayMessage();
      validator.reset() 
      return;
    };

    let api = Api;
    api.setUserToken();

    const apiPayload = getOnlyChangedValuesForApiPayload({
      newData: apiDetailsFormsData,
      originalData: defaultApiDetailsFormsObject
    });

    api.axios().put(Settings.apiAppUrl+`/lynkaz-api/${id}/`, apiPayload).then(function(res){
      if(res?.status === 200){
        Helper.alert(res?.data?.message || 'Lynkaz api details updated successfully', 'success');
        getApiDetailsFormsById();
      } else {
        Helper.alert(res?.data?.message, 'error')
      }
    }).catch((res) => {  
      getPopupMessageBasedOnStatus(res);
    })  
  }

  return (
    <div className='container-fluid'>
      <NavigationHeder title={ `<span style="color:#000;"> Edit Api Details #</span> ${apiDetailsFormsData.title}` }>
        <LinkBtn to={-1} isActive= {false} title={"Close"} />
        <Button isActive= {true} onClick ={SaveHandler} title={"Save"} icon={'/images/icons/save-white.svg'} />
      </NavigationHeder>

      {loading ? <SimpleLoading /> : (
        <Fragment>
          {ApiDetailsForms()} 
        </Fragment>
      )} 
    </div>
  )
}

export default (MasterComponentWraper(ApiDetailsFormsDetailView));